import { FC } from "react";
import { HomeBannerCont } from "./homeBannerOne.styled";
import { useTheme } from "styled-components";
import Image from "../../../../../../componentReusable/Image";
import { classNames } from "helpers/themeHelpers";
import { isShobiddak } from "helpers/osHelpers";
const HomeBannerOne: FC = () => {
  const { locale, isDesktop, country } = useTheme();
  return (
      <HomeBannerCont
          isShobiddak={isShobiddak() || country === "ps"}
          id="homeBannerOne"
          {...classNames("center width-100", isDesktop && "HomeBannerConDesktop")}
      >
        {isDesktop ? (
            <div className="absolute">
              <Image
                  src={`/images/homePage/desktop/homeBannerDesktopOne-${
                      isShobiddak() || country === "ps" ? "shobiddak-" : ""
                  }${locale}.webp`}
                  alt="Buy and Sell"
                  className="height-100"
                  width="1200"
                  height="260"
              />
            </div>
        ) : (
            <Image
                src={`/images/homePage/mobile/homeBannerMobileOne-${
                    isShobiddak() || country === "ps" ? "shobiddak-" : ""
                }${locale}.webp`}
                alt="Buy and Sell"
                width="100%"
                height="115"
                className="height-100"
                id="homeBannerMobileOne"
                loading="lazy"
            />
        )}
      </HomeBannerCont>
  );
};

export default HomeBannerOne;
